// FASE 05 — Cadastros Gerais > Linhas (especificação de 14/08/2026).
// O cadastro migrou do MOF legado para cá; regras iguais, layout no padrão do
// Cadastro de Projetista, mais os três campos novos.

export interface ILinha {
  idLinha: number;
  descricao: string;
  logo?: string;
  // Logo em data URI — a tabela Linhas guarda os bytes (LogoByteArray).
  logoBase64?: string;
  tipoSistemaLinha?: string;
  idNivelSistema?: number | null;
  nivelSistema?: string;
  // Decisão P3 (02/10/2026): o switch "Gerar no pacote de Referências" voltou para a Linha, revogando a
  // opção A de 23/09 (caixa do vínculo). Ligado (default) = os cadastros N1 da linha entram no pacote
  // da referência; desligado = saem em pacote separado de referência + linha.
  gerarNoPacoteReferencia?: boolean;
  prenativos?: IPrenativoLinha[];
}

export interface IPrenativoLinha {
  idPrenativo: number;
  idPrenativoLinha?: number;
  codigo?: string;
  descricao?: string;
  tipo?: string;
  unidade?: string;
  idUnidadeItemEmbalagem?: number;
}

export interface ISalvarLinha {
  idLinha?: number;
  descricao: string;
  tipoSistemaLinha: string;
  idNivelSistema: number | null;
  gerarNoPacoteReferencia: boolean;
  logoBase64?: string;
  logoFormato?: string;
  logoAlterada?: boolean;
}

export interface IApiResponseLinhas {
  data: ILinha[];
  page?: number;
  totalPages?: number;
  totalRecords?: number;
  paginate?: boolean;
}

export const NIVEIS_SISTEMA_LINHA = [
  { value: 1, label: "Alto padrão" },
  { value: 2, label: "Intermediário" },
  { value: 3, label: "Baixo padrão" },
];
